import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation, useMatch, useNavigate } from 'react-router';
import { Link, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconName, IconProp } from '@fortawesome/fontawesome-svg-core';
import Logo from './assets/nxvet.svg?react';
import Dashboard from './assets/dashboard.svg?react';
import DashboardActive from './assets/dashboard-active.svg?react';
import Building from './assets/building.svg?react';
import BuildingActive from './assets/building-active.svg?react';
import Billing from './assets/billing.svg?react';
import BillingActive from './assets/billing-active.svg?react';
import './assets/nxvet.svg';
// import ArrowDark from './assets/arrow-dark.svg?react';
import './assets/arrow-dark.svg';
// import WhatNew from './assets/what-new.svg?react';
// import './assets/what-new.svg';
// import Support from './assets/support.svg?react';
import './assets/support.svg';
import Menuarrow from './assets/menu-arrow.svg?react';
import './assets/menu-arrow.svg';
// import WhatNewActive from './assets/what-new-active.svg?react';
// import './assets/what-new-active.svg';
// import SupportActive from './assets/support-active.svg?react';
// import './assets/support-active.svg';
import './assets/nxvet.png';
import './assets/dashboard.svg';
import './assets/dashboard-active.svg';
import './assets/building.svg';
import './assets/building-active.svg';
import './assets/billing.svg';
import './assets/billing-active.svg';
import RecordingControls from 'web/components/RecordingControls';
import PhoneCallUI from 'web/components/PhoneCallUI';
import SupportFormPopup from 'web/components/SupportFormPopup';
// import { Dropdown } from 'react-daisyui';
import { useCurrentUser } from './hooks/useCurrentUser';
import { useCurrentOrganization } from './hooks/useCurrentOrganization';
import CallToSubscribeBanner from './components/CallToSubscribeBanner';
import classNames from 'classnames';
import ApiConnectivityBanner from './components/ApiConnectivityBanner';
import NetworkConnectivityBanner from './components/NetworkConnectivityBanner';

export const Layout = () => {
    const [isSupportFormOpen, setSupportFormOpen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const user = useCurrentUser();
    const { currentOrganization } = useCurrentOrganization();
    const location = useLocation();
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const modalRef: any = useRef();

    // Check if user is subscribed
    const isSubscribed = currentOrganization?.isSubscribed ?? false;
    const isNxCallSubscribed = currentOrganization?.isStripeNxCallSubscribedCache
        || (currentOrganization?.nxCallForceSubscriptionEndDate && currentOrganization?.nxCallForceSubscriptionEndDate > new Date());
  

    // Handle click for non-subscribed users
    const handleNonSubscribedClick = (e: React.MouseEvent) => {
        e.preventDefault();
        navigate('/billing');
    };

    // Toggle Modal Open/Close
    // const toggleModal = () => {
    //     setIsModalOpen(!isModalOpen);
    // };

    // Close Modal if clicked outside
    useEffect(() => {
        const handleClickOutside = (event: { target: any; }) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setIsModalOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (user.isAdmin) return;

        if (location.pathname !== '/no-organization' && user.organizations?.length === 0) {
            navigate('/no-organization');
        }
        
        // Redirect new users to patients page instead of start-subscription
        if (location.pathname === '/' && currentOrganization && !isSubscribed) {
            navigate('/patients');
        }
    }, [location.pathname, currentOrganization, isSubscribed, navigate]);

    const checkPatientsInURL = (url: string) => {
        // Check if 'patients' exists in the URL path
        return window.location.pathname.includes(url);
    };

    return (
        <div className='flex flex-row items-stretch min-h-screen w-screen'>
            <NetworkConnectivityBanner />
            <ApiConnectivityBanner />
            <div className={classNames('pt-[36px] px-[12px] flex flex-col patients-tour transition-all duration-300', isCollapsed ? 'w-[80px]' : 'w-[240px]')}>
                <div className="flex items-center justify-between mb-4">
                    {!isCollapsed && <Logo width="100%" height="48px" viewBox='0 0 1138 477' />}
                    <button
                        onClick={() => setIsCollapsed(!isCollapsed)}
                        className="p-2 rounded-lg hover:bg-gray-200 transition-colors"
                        title={isCollapsed ? "Expand menu" : "Collapse menu"}
                    >
                        <FontAwesomeIcon icon={isCollapsed ? "chevron-right" : "chevron-left"} className="text-white" />
                    </button>
                </div>
                <ul className='flex-1 mt-[24px] flex flex-col gap-[8px]'>
                    {/* <LeftNavLink to="/dashboard" text="Dashboard" ActiveIcon={DashboardActive} InactiveIcon={Dashboard} isCollapsed={isCollapsed} /> */}
                    <LeftNavLink to="/patients" text="Patients" ActiveIcon={DashboardActive} InactiveIcon={Dashboard} isCollapsed={isCollapsed} />

                    <LeftNavLink
                        to="/review-center"
                        text="Review Center"
                        ActiveIcon="chart-line"
                        InactiveIcon="chart-line"
                        isGreyedOut={!isSubscribed}
                        onGreyedOutClick={handleNonSubscribedClick}
                        isCollapsed={isCollapsed}
                    />

                    <LeftNavLink
                        to="/audio-recordings"
                        text="Audio Recordings"
                        ActiveIcon="microphone"
                        InactiveIcon="microphone"
                        isGreyedOut={!isSubscribed}
                        onGreyedOutClick={handleNonSubscribedClick}
                        isCollapsed={isCollapsed}
                    />
                    <LeftNavLink
                        to="/documents"
                        text="Documents"
                        ActiveIcon="file-alt"
                        InactiveIcon="file-alt"
                        isGreyedOut={!isSubscribed}
                        onGreyedOutClick={handleNonSubscribedClick}
                        isCollapsed={isCollapsed}
                    />
                    <LeftNavLink to="/nxvet-devices" text="Devices" ActiveIcon="microchip" InactiveIcon="microchip" isCollapsed={isCollapsed} />
                    <LeftNavLink to="/nxhub-status" text="NxHUB Status" ActiveIcon="tower-broadcast" InactiveIcon="tower-broadcast" isCollapsed={isCollapsed} />
                    {(user.isAdmin || isNxCallSubscribed) && (
                        <LeftNavLink
                            to="/nxvet-calls"
                            text="NxCALL"
                            ActiveIcon="phone"
                            InactiveIcon="phone"
                            onGreyedOutClick={handleNonSubscribedClick}
                            isCollapsed={isCollapsed}
                        />
                    )}
                    <LeftNavGroup name="Organization" ActiveIcon={BuildingActive} InactiveIcon={Building} isCollapsed={isCollapsed}>
                        <LeftNavLink to="/organization" text="Members" ActiveIcon="user-group" InactiveIcon="user-group" isCollapsed={isCollapsed} />
                        {/* Hide Preferences and Templates for non-subscribed users */}
                        {isSubscribed && (
                            <>
                                <LeftNavLink to="/preferences" text="Preferences" ActiveIcon="gear" InactiveIcon="gear" isCollapsed={isCollapsed} />
                                <LeftNavLink to="/medical-record-template" text="Templates" ActiveIcon="file-medical" InactiveIcon="file-medical" isCollapsed={isCollapsed} />
                            </>
                        )}
                        <LeftNavLink to="/billing" text="Billing" ActiveIcon={BillingActive} InactiveIcon={Billing} isCollapsed={isCollapsed} />
                        {(user.isAdmin || currentOrganization?.owners?.some(o => o.id === user.id)) && (
                            <LeftNavLink to="/integrations" text="Integrations" ActiveIcon="plug" InactiveIcon="plug" isCollapsed={isCollapsed} />
                        )}
                        {(user.isAdmin || currentOrganization?.owners?.some(o => o.id === user.id)) && (
                            <LeftNavLink to="/nxhub-recordings" text="NxHUB Intelligence" ActiveIcon="brain" InactiveIcon="brain" isCollapsed={isCollapsed} />
                        )}
                        {(user.isAdmin || currentOrganization?.orgHasHypercareEnabled) && (
                            <LeftNavLink to="/hypercare" text="Hypercare" ActiveIcon="hand-holding-medical" InactiveIcon="hand-holding-medical" isCollapsed={isCollapsed} />
                        )}
                    </LeftNavGroup>

                    <LeftNavGroup name="Alpha Features" ActiveIcon="vial" InactiveIcon="vial" adminOnly={true} isCollapsed={isCollapsed}>
                        {/* AI Chat now lives inside NxHUB Intelligence as the "Ask" tab
                            (owner-gated). The standalone /ai-chat route is kept for
                            deep-links but no longer has its own admin-only nav entry. */}
                        <LeftNavLink key="monitor" to="/monitoring-panel" text="Monitoring" ActiveIcon="heartbeat" InactiveIcon="heartbeat" isCollapsed={isCollapsed} />
                        <LeftNavLink key="statistics" to="/statistics" text="Statistics" ActiveIcon="chart-simple" InactiveIcon="chart-simple" isCollapsed={isCollapsed} />
                        <LeftNavLink key="referral" to="/referral" text="Referral" ActiveIcon="user-group" InactiveIcon="user-group" isCollapsed={isCollapsed} />
                        <LeftNavLink key="speaker-id" to="/speaker-identification" text="Speaker ID" ActiveIcon="microphone-lines" InactiveIcon="microphone-lines" isCollapsed={isCollapsed} />
                        <LeftNavLink
                            key="staff-alerts"
                            to="/staff-alerts"
                            text="Staff Alerts"
                            ActiveIcon="bell"
                            InactiveIcon="bell"
                            isGreyedOut={!isSubscribed}
                            onGreyedOutClick={handleNonSubscribedClick}
                            isCollapsed={isCollapsed}
                        />
                    </LeftNavGroup>
                    <LeftNavGroup name='Admin' ActiveIcon="lock" InactiveIcon="lock" adminOnly={true} isCollapsed={isCollapsed}>
                        <LeftNavLink key="labels" to="/labels" text="Labels" ActiveIcon="tag" InactiveIcon="tag" isCollapsed={isCollapsed} />
                        <LeftNavLink key="labels-calibration" to="/labels-calibration" text="Calibration" ActiveIcon="calculator" InactiveIcon="calculator" isCollapsed={isCollapsed} />
                        <LeftNavLink key="devices" to="/devices" text="Devices" ActiveIcon="radio" InactiveIcon="radio" isCollapsed={isCollapsed} />
                        <LeftNavLink key="device-templates" to="/device-templates" text="Device Templates" ActiveIcon="folder-tree" InactiveIcon="folder-tree" isCollapsed={isCollapsed} />
                        <LeftNavLink key="device-data" to="/device-data" text="Device data" ActiveIcon="database" InactiveIcon="database" isCollapsed={isCollapsed} />
                        <LeftNavLink key="users" to="/admin/users" text="Users" ActiveIcon="user" InactiveIcon="user" isCollapsed={isCollapsed} />
                        <LeftNavLink key="referral" to="/admin/referrals" text="Referrals" ActiveIcon="hand-holding-heart" InactiveIcon="hand-holding-heart" isCollapsed={isCollapsed} />
                        <LeftNavLink key="admin-orgs" to="/admin/organizations" text="All Organizations" ActiveIcon="building-lock" InactiveIcon="building-lock" isCollapsed={isCollapsed} />
                        <LeftNavLink key="modified-patient-notes" to="/admin/modified-patient-notes" text="Modified SOAP" ActiveIcon="book" InactiveIcon="book" isCollapsed={isCollapsed} />
                        <LeftNavLink key="org-admin-stat" to="/admin/statistics" text="Statistics" ActiveIcon="chart-simple" InactiveIcon="chart-simple" isCollapsed={isCollapsed} />
                        <LeftNavLink key="nxscope-firmware" to="/admin/nxscope-firmware" text="NxSCOPE Firmware" ActiveIcon="microchip" InactiveIcon="microchip" isCollapsed={isCollapsed} />
                        <LeftNavLink key="nxhub-firmware" to="/admin/nxhub-firmware" text="NxHUB Firmware" ActiveIcon="microchip" InactiveIcon="microchip" isCollapsed={isCollapsed} />
                        <LeftNavLink key="nxhub-fw-analytics" to="/admin/nxhub-firmware-analytics" text="NxHUB FW Analytics" ActiveIcon="chart-bar" InactiveIcon="chart-bar" isCollapsed={isCollapsed} />
                        <LeftNavLink key="growth-stats" to="/admin/growth-statistics" text="Growth Statistics" ActiveIcon="chart-line" InactiveIcon="chart-line" isCollapsed={isCollapsed} />
                        <LeftNavLink key="nxscope-logs" to="/admin/nxscope-logs" text="NxSCOPE Logs" ActiveIcon="file-alt" InactiveIcon="file-alt" isCollapsed={isCollapsed} />
                    </LeftNavGroup>
                </ul>

                <div className="flex flex-col">
                    <div className='flex flex-col gap-[8px] pb-[10px]'>
                        {/* <Link key="what-new" to='/what-new'>
                <div  className={checkPatientsInURL('/what-new') ? "flex gap-[12px] items-center text-[#171717] py-[9px] px-[12px] block rounded-[8px] font-[600] text-[14px] bg-[#E4F5F8] text-[#26818E]" : "flex gap-[12px] items-center text-[#171717] py-[9px] px-[12px] block rounded-[8px] font-[600] text-[14px]"}>
                 {checkPatientsInURL('/what-new') ? <WhatNewActive /> : <WhatNew/> } What's new?
                </div>
                </Link> */}

                        <div>
                            {/* <div
                                className="cursor-pointer flex gap-[12px] items-center text-[#171717] py-[9px] px-[12px] block rounded-[8px] font-[600] text-[14px]"
                                onClick={toggleModal}
                            >
                                <Support /> Support
                            </div> */}

                            {isModalOpen && (
                                <div
                                    ref={modalRef}
                                    className="absolute bottom-[133px] w-[260px] left-[16px] transform border border-[#E9E9E9]  bg-white shadow-lg rounded-[6px] z-10"
                                >
                                    <div className="px-[24px] leading-4 py-[15.5px] border-b text-[16px] font-[700] border-[#E9E9E9] text-[#26818E]">Support</div>
                                    <div className='py-[16px] px-[12px]'>
                                        <Link key="give-feedback" to='/give-feedback'>
                                            <div className={checkPatientsInURL('/give-feedback') || checkPatientsInURL('/labels') ? "flex mb-[8px] gap-[12px] justify-between items-center text-[#171717] py-[10.5px] pl-[24px] pr-[16px] block rounded-[8px] font-[600] text-[14px] bg-[#F4F6F8] text-[#171717]" : "flex mb-[8px] justify-between gap-[12px] items-center text-[#171717]/[80%] py-[10.5px] pl-[24px] pr-[16px] block rounded-[8px] font-[600] text-[14px]"}>
                                                Give feedback <Menuarrow />
                                            </div>
                                        </Link>
                                        <Link key="faq" to='/faq'>
                                            <div className={checkPatientsInURL('/faq') || checkPatientsInURL('/labels') ? "flex mb-[8px] gap-[12px] justify-between items-center text-[#171717] py-[10.5px] pl-[24px] pr-[16px] block rounded-[8px] font-[600] text-[14px] bg-[#F4F6F8] text-[#171717]" : "flex mb-[8px] justify-between gap-[12px] items-center text-[#171717]/[80%] py-[10.5px] pl-[24px] pr-[16px] block rounded-[8px] font-[600] text-[14px]"}>
                                                FAQ <Menuarrow />
                                            </div>
                                        </Link>
                                        <Link key="video-guides" to='/video-guides'>
                                            <div className={checkPatientsInURL('/video-guides') || checkPatientsInURL('/labels') ? "flex gap-[12px] justify-between items-center text-[#171717] py-[10.5px] pl-[24px] pr-[16px] block rounded-[8px] font-[600] text-[14px] bg-[#F4F6F8] text-[#171717]" : "flex justify-between gap-[12px] items-center text-[#171717]/[80%] py-[10.5px] pl-[24px] pr-[16px] block rounded-[8px] font-[600] text-[14px]"}>
                                                Video Guides <Menuarrow />
                                            </div>
                                        </Link>

                                    </div>

                                </div>
                            )}
                        </div>

                        {/* <Link key="support" to='/'>
                <div className={checkPatientsInURL('/') ? "flex gap-[12px] items-center text-[#171717] py-[9px] px-[12px] block rounded-[8px] font-[600] text-[14px]" : "flex gap-[12px] items-center text-[#171717] py-[9px] px-[12px] block rounded-[8px] font-[600] text-[14px]"}>
                 {checkPatientsInURL('/') ? <Support /> : <Support /> } Support@
                </div>
                </Link> */}


                    </div>

                    {!isCollapsed && <CallToSubscribeBanner />}
                </div>
            </div>
            <div className='flex-1  pt-[16px] px-[24px] bg-[#F4F6F8] min-h-screen overflow-x-hidden overflow-y-scroll grow' id='page-content'>
                <Outlet />
                <RecordingControls />
                <PhoneCallUI />
                <button
                    className="fixed bottom-4 right-4 primary text-white px-4 py-2 !rounded-full shadow-lg"
                    onClick={() => setSupportFormOpen(true)}
                >
                    Support
                </button>
                {isSupportFormOpen && <SupportFormPopup onClose={() => setSupportFormOpen(false)} user={user} />}
            </div>
        </div>
    );
}

declare type LeftNavGroupProps = {
    name: string;
    adminOnly?: boolean;
    children?: React.ReactNode[];
    ActiveIcon: React.ComponentType<{ className?: string }> | IconName,
    InactiveIcon: React.ComponentType<{ className?: string }> | IconName,
    pathnamePattern?: string;
    isCollapsed?: boolean;
};

const LeftNavGroup = (props: LeftNavGroupProps) => {
    const user = useCurrentUser();
    const [isExpanded, setIsExpanded] = useState(true);

    if ((props.adminOnly ?? false) && !user.isAdmin) return null;

    const isActive = useMatch(props.pathnamePattern ?? 'no-pathname-parttern');

    const ActiveIcon = typeof props.ActiveIcon === 'string' ? () => <FontAwesomeIcon icon={props.ActiveIcon as IconProp} /> : props.ActiveIcon;
    const InactiveIcon = typeof props.InactiveIcon === 'string' ? () => <FontAwesomeIcon icon={props.InactiveIcon as IconProp} /> : props.InactiveIcon;

    const Icon = isActive ? ActiveIcon : InactiveIcon;

    if (!user.isAdmin && props.adminOnly) {
        return null;
    }

    // When collapsed, don't show group - just show children directly
    if (props.isCollapsed) {
        return (
            <>
                {props.children}
            </>
        );
    }

    return (
        <li>
            <div>
                <div
                    className={classNames(
                        "flex gap-[12px] items-center text-[#171717] py-[9px] px-[12px] rounded-[8px] font-[600] text-[14px] cursor-pointer",
                        isActive && "bg-[#E4F5F8] text-[#26818E]"
                    )}
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    <div className='w-7 h-7 flex items-center justify-center'>
                        <Icon />
                    </div>
                    {props.name}
                    <FontAwesomeIcon
                        icon={isExpanded ? "chevron-down" : "chevron-right"}
                        className="ml-auto text-xs"
                    />
                </div>
            </div>
            {isExpanded && (
                <ul className='pl-[33px]'>
                    {props.children}
                </ul>
            )}
        </li>
    );
};

const LeftNavLink = (props: {
    to: string,
    text: string,
    icon?: IconProp,
    ActiveIcon: React.ComponentType<{ className?: string }> | IconName,
    InactiveIcon: React.ComponentType<{ className?: string }> | IconName,
    className?: string,
    isGreyedOut?: boolean,
    onGreyedOutClick?: (e: React.MouseEvent) => void,
    isCollapsed?: boolean,
}) => {
    const ActiveIcon = typeof props.ActiveIcon === 'string' ? () => <FontAwesomeIcon icon={props.ActiveIcon as IconProp} /> : props.ActiveIcon;
    const InactiveIcon = typeof props.InactiveIcon === 'string' ? () => <FontAwesomeIcon icon={props.InactiveIcon as IconProp} /> : props.InactiveIcon;

    if (props.isGreyedOut) {
        return (
            <li className="relative group">
                <div
                    className={classNames(
                        "flex gap-[12px] items-center py-[9px] px-[12px] rounded-[8px] font-[600] text-[14px] cursor-pointer",
                        "text-gray-400 opacity-100",
                        props.isCollapsed ? "justify-center" : "",
                        props.className ?? ""
                    )}
                    onClick={props.onGreyedOutClick}
                    title={props.isCollapsed ? props.text : undefined}
                >
                    <div className='w-7 h-7 flex items-center justify-center'>
                        <InactiveIcon />
                    </div>
                    {!props.isCollapsed && props.text}
                </div>
                {props.isCollapsed && (
                    <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap z-50 top-1/2 -translate-y-1/2">
                        {props.text}
                    </div>
                )}
            </li>
        );
    }

    return (
        <li className="relative group">
            <NavLink to={props.to} className={({ isActive }) => classNames("flex gap-[12px] items-center text-[#171717] py-[9px] px-[12px] rounded-[8px] font-[600] text-[14px]",
                isActive ? "bg-[#E4F5F8] text-[#26818E]" : "",
                props.isCollapsed ? "justify-center" : "",
                props.className ?? "")}
                title={props.isCollapsed ? props.text : undefined}
            >
                {({ isActive }) => isActive ? (
                    <>
                        <div className='w-7 h-7 flex items-center justify-center'>
                            <ActiveIcon />
                        </div>
                        {!props.isCollapsed && props.text}
                    </>
                ) : (
                    <>
                        <div className='w-7 h-7 flex items-center justify-center'>
                            <InactiveIcon />
                        </div>
                        {!props.isCollapsed && props.text}
                    </>
                )}
            </NavLink>
            {props.isCollapsed && (
                <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap z-50 top-1/2 -translate-y-1/2">
                    {props.text}
                </div>
            )}
        </li>
    )
}
